import { get, post, jsonpost } from "../baseConfig/http";
import apiConfig from "../baseConfig/apiConfig";

// 登录
export const userlogin = (params) => post(apiConfig.userApi.login, params);
export const userreg = (params) => post(apiConfig.userApi.userreg, params);
export const editpass = (params) => post(apiConfig.userApi.editpass, params);
export const forgetpass = (params) => post(apiConfig.userApi.forgetpass, params);
// 获取用户信息
export const getuserinfo = (params) => post(apiConfig.userApi.userinfo, params);
export const sendacode = (params) => post(apiConfig.userApi.sendacode, params);

// 用户安全退出
export const loginout = (params) => post(apiConfig.userApi.loginout, params);

export const resources = (params) => post(apiConfig.userApi.resources, params);
export const batchs = (params) => jsonpost(apiConfig.userApi.batchs, params);
export const cancel = (params) => post(apiConfig.userApi.cancel, params);
export const deleteyy = (params) => post(apiConfig.userApi.deleteyy, params);
export const updateyy = (params) =>
  jsonpost(apiConfig.userApi.updateyy, params);
export const myorders = (params) => post(apiConfig.userApi.myorders, params);

//上传文件
export const fileup = (params) => post(apiConfig.uploadApi.fileup, params);

export const downloadResource = apiConfig.uploadApi.downfile;
export const progress = (params) => post(apiConfig.userApi.progress, params);
export const uppingz = (params) => jsonpost(apiConfig.userApi.uppingz, params);



// WEBPACK FOOTER //
// ./src/request/api/user.js